import * as Q from "react";
import Jr, { forwardRef as Kr, useContext as Dt, useRef as Mt, useEffect as Ft, useMemo as jt } from "react";
import { isObject as Hr } from "@illa-design/system";
import { keyframes as Vt, css as ae } from "@emotion/react";
import { globalColor as ee, illaPrefix as U, deleteCssProps as Zr, applyBoxStyle as Yt } from "@illa-design/theme";
var ir = { exports: {} }, be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Lt() {
  if (Ar)
    return be;
  Ar = 1;
  var e = Jr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, v) {
    var d, y = {}, $ = null, _ = null;
    v !== void 0 && ($ = "" + v), p.key !== void 0 && ($ = "" + p.key), p.ref !== void 0 && (_ = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: $, ref: _, props: y, _owner: o.current };
  }
  return be.Fragment = n, be.jsx = f, be.jsxs = f, be;
}
var _e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kr;
function Wt() {
  return kr || (kr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Jr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), S = Symbol.iterator, E = "@@iterator";
    function D(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = S && t[S] || t[E];
      return typeof s == "function" ? s : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        A("error", t, u);
      }
    }
    function A(t, s, u) {
      {
        var m = x.ReactDebugCurrentFrame, w = m.getStackAddendum();
        w !== "" && (s += "%s", u = u.concat([w]));
        var k = u.map(function(R) {
          return String(R);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, k);
      }
    }
    var I = !1, c = !1, V = !1, N = !1, Je = !1, Te;
    Te = Symbol.for("react.module.reference");
    function Ke(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Je || t === o || t === v || t === d || N || t === _ || I || c || V || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Te || t.getModuleId !== void 0));
    }
    function He(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var w = s.displayName || s.name || "";
      return w !== "" ? u + "(" + w + ")" : u;
    }
    function Oe(t) {
      return t.displayName || "Context";
    }
    function G(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return Oe(s) + ".Consumer";
          case f:
            var u = t;
            return Oe(u._context) + ".Provider";
          case p:
            return He(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : G(t.type) || "Memo";
          case $: {
            var w = t, k = w._payload, R = w._init;
            try {
              return G(R(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, te = 0, Pe, $e, pe, Ne, he, Ae, ke;
    function Ie() {
    }
    Ie.__reactDisabledLog = !0;
    function Ze() {
      {
        if (te === 0) {
          Pe = console.log, $e = console.info, pe = console.warn, Ne = console.error, he = console.group, Ae = console.groupCollapsed, ke = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function Xe() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, t, {
              value: Pe
            }),
            info: Z({}, t, {
              value: $e
            }),
            warn: Z({}, t, {
              value: pe
            }),
            error: Z({}, t, {
              value: Ne
            }),
            group: Z({}, t, {
              value: he
            }),
            groupCollapsed: Z({}, t, {
              value: Ae
            }),
            groupEnd: Z({}, t, {
              value: ke
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ve = x.ReactCurrentDispatcher, me;
    function oe(t, s, u) {
      {
        if (me === void 0)
          try {
            throw Error();
          } catch (w) {
            var m = w.stack.trim().match(/\n( *(at )?)/);
            me = m && m[1] || "";
          }
        return `
` + me + t;
      }
    }
    var ye = !1, ie;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      ie = new Qe();
    }
    function h(t, s) {
      if (!t || ye)
        return "";
      {
        var u = ie.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      ye = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = ve.current, ve.current = null, Ze();
      try {
        if (s) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (X) {
              m = X;
            }
            Reflect.construct(t, [], R);
          } else {
            try {
              R.call();
            } catch (X) {
              m = X;
            }
            t.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (X) {
            m = X;
          }
          t();
        }
      } catch (X) {
        if (X && m && typeof X.stack == "string") {
          for (var b = X.stack.split(`
`), W = m.stack.split(`
`), M = b.length - 1, F = W.length - 1; M >= 1 && F >= 0 && b[M] !== W[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (b[M] !== W[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || b[M] !== W[F]) {
                    var q = `
` + b[M].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && ie.set(t, q), q;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ye = !1, ve.current = k, Xe(), Error.prepareStackTrace = w;
      }
      var ue = t ? t.displayName || t.name : "", Nr = ue ? oe(ue) : "";
      return typeof t == "function" && ie.set(t, Nr), Nr;
    }
    function Ee(t, s, u) {
      return h(t, !1);
    }
    function se(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ne(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return h(t, se(t));
      if (typeof t == "string")
        return oe(t);
      switch (t) {
        case v:
          return oe("Suspense");
        case d:
          return oe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return Ee(t.render);
          case y:
            return ne(t.type, s, u);
          case $: {
            var m = t, w = m._payload, k = m._init;
            try {
              return ne(k(w), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var De = Object.prototype.hasOwnProperty, gr = {}, br = x.ReactDebugCurrentFrame;
    function Me(t) {
      if (t) {
        var s = t._owner, u = ne(t.type, t._source, s ? s.type : null);
        br.setExtraStackFrame(u);
      } else
        br.setExtraStackFrame(null);
    }
    function vt(t, s, u, m, w) {
      {
        var k = Function.call.bind(De);
        for (var R in t)
          if (k(t, R)) {
            var b = void 0;
            try {
              if (typeof t[R] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[R](s, R, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              b = M;
            }
            b && !(b instanceof Error) && (Me(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, R, typeof b), Me(null)), b instanceof Error && !(b.message in gr) && (gr[b.message] = !0, Me(w), g("Failed %s type: %s", u, b.message), Me(null));
          }
      }
    }
    var mt = Array.isArray;
    function er(t) {
      return mt(t);
    }
    function yt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function Et(t) {
      try {
        return _r(t), !1;
      } catch {
        return !0;
      }
    }
    function _r(t) {
      return "" + t;
    }
    function xr(t) {
      if (Et(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yt(t)), _r(t);
    }
    var ge = x.ReactCurrentOwner, gt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Sr, Rr, rr;
    rr = {};
    function bt(t) {
      if (De.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function _t(t) {
      if (De.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function xt(t, s) {
      if (typeof t.ref == "string" && ge.current && s && ge.current.stateNode !== s) {
        var u = G(ge.current.type);
        rr[u] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(ge.current.type), t.ref), rr[u] = !0);
      }
    }
    function St(t, s) {
      {
        var u = function() {
          Sr || (Sr = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function Rt(t, s) {
      {
        var u = function() {
          Rr || (Rr = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var wt = function(t, s, u, m, w, k, R) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: R,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Ct(t, s, u, m, w) {
      {
        var k, R = {}, b = null, W = null;
        u !== void 0 && (xr(u), b = "" + u), _t(s) && (xr(s.key), b = "" + s.key), bt(s) && (W = s.ref, xt(s, w));
        for (k in s)
          De.call(s, k) && !gt.hasOwnProperty(k) && (R[k] = s[k]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (k in M)
            R[k] === void 0 && (R[k] = M[k]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && St(R, F), W && Rt(R, F);
        }
        return wt(t, b, W, w, m, ge.current, R);
      }
    }
    var tr = x.ReactCurrentOwner, wr = x.ReactDebugCurrentFrame;
    function ce(t) {
      if (t) {
        var s = t._owner, u = ne(t.type, t._source, s ? s.type : null);
        wr.setExtraStackFrame(u);
      } else
        wr.setExtraStackFrame(null);
    }
    var nr;
    nr = !1;
    function ar(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Cr() {
      {
        if (tr.current) {
          var t = G(tr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Tt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Tr = {};
    function Ot(t) {
      {
        var s = Cr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Or(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Ot(s);
        if (Tr[u])
          return;
        Tr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== tr.current && (m = " It was passed a child from " + G(t._owner.type) + "."), ce(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ce(null);
      }
    }
    function Pr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (er(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            ar(m) && Or(m, s);
          }
        else if (ar(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = D(t);
          if (typeof w == "function" && w !== t.entries)
            for (var k = w.call(t), R; !(R = k.next()).done; )
              ar(R.value) && Or(R.value, s);
        }
      }
    }
    function Pt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = G(s);
          vt(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !nr) {
          nr = !0;
          var w = G(s);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $t(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            ce(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ce(null);
            break;
          }
        }
        t.ref !== null && (ce(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), ce(null));
      }
    }
    function $r(t, s, u, m, w, k) {
      {
        var R = Ke(t);
        if (!R) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Tt(w);
          W ? b += W : b += Cr();
          var M;
          t === null ? M = "null" : er(t) ? M = "array" : t !== void 0 && t.$$typeof === r ? (M = "<" + (G(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, b);
        }
        var F = Ct(t, s, u, w, k);
        if (F == null)
          return F;
        if (R) {
          var q = s.children;
          if (q !== void 0)
            if (m)
              if (er(q)) {
                for (var ue = 0; ue < q.length; ue++)
                  Pr(q[ue], t);
                Object.freeze && Object.freeze(q);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pr(q, t);
        }
        return t === a ? $t(F) : Pt(F), F;
      }
    }
    function Nt(t, s, u) {
      return $r(t, s, u, !0);
    }
    function At(t, s, u) {
      return $r(t, s, u, !1);
    }
    var kt = At, It = Nt;
    _e.Fragment = a, _e.jsx = kt, _e.jsxs = It;
  }()), _e;
}
process.env.NODE_ENV === "production" ? ir.exports = Lt() : ir.exports = Wt();
var Le = ir.exports;
function zt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Ut(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Bt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ut(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = zt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", We = "-moz-", C = "-webkit-", pr = "comm", hr = "rule", vr = "decl", qt = "@import", Xr = "@keyframes", Gt = "@layer", Jt = Math.abs, Ue = String.fromCharCode, Kt = Object.assign;
function Ht(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function Qr(e) {
  return e.trim();
}
function Zt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function T(e, r, n) {
  return e.replace(r, n);
}
function sr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function Se(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function mr(e) {
  return e.length;
}
function Fe(e, r) {
  return r.push(e), e;
}
function Xt(e, r) {
  return e.map(r).join("");
}
var Be = 1, le = 1, et = 0, z = 0, j = 0, de = "";
function qe(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Be, column: le, length: f, return: "" };
}
function xe(e, r) {
  return Kt(qe("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Qt() {
  return j;
}
function en() {
  return j = z > 0 ? Y(de, --z) : 0, le--, j === 10 && (le = 1, Be--), j;
}
function B() {
  return j = z < et ? Y(de, z++) : 0, le++, j === 10 && (le = 1, Be++), j;
}
function H() {
  return Y(de, z);
}
function je() {
  return z;
}
function Ce(e, r) {
  return Se(de, e, r);
}
function Re(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function rt(e) {
  return Be = le = 1, et = K(de = e), z = 0, [];
}
function tt(e) {
  return de = "", e;
}
function Ve(e) {
  return Qr(Ce(z - 1, cr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rn(e) {
  for (; (j = H()) && j < 33; )
    B();
  return Re(e) > 2 || Re(j) > 3 ? "" : " ";
}
function tn(e, r) {
  for (; --r && B() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Ce(e, je() + (r < 6 && H() == 32 && B() == 32));
}
function cr(e) {
  for (; B(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && cr(j);
        break;
      case 40:
        e === 41 && cr(e);
        break;
      case 92:
        B();
        break;
    }
  return z;
}
function nn(e, r) {
  for (; B() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && H() === 47)
      break;
  return "/*" + Ce(r, z - 1) + "*" + Ue(e === 47 ? e : B());
}
function an(e) {
  for (; !Re(H()); )
    B();
  return Ce(e, z);
}
function on(e) {
  return tt(Ye("", null, null, null, [""], e = rt(e), 0, [0], e));
}
function Ye(e, r, n, a, o, i, f, l, p) {
  for (var v = 0, d = 0, y = f, $ = 0, _ = 0, S = 0, E = 1, D = 1, x = 1, g = 0, A = "", I = o, c = i, V = a, N = A; D; )
    switch (S = g, g = B()) {
      case 40:
        if (S != 108 && Y(N, y - 1) == 58) {
          sr(N += T(Ve(g), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        N += Ve(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        N += rn(S);
        break;
      case 92:
        N += tn(je() - 1, 7);
        continue;
      case 47:
        switch (H()) {
          case 42:
          case 47:
            Fe(sn(nn(B(), je()), r, n), p);
            break;
          default:
            N += "/";
        }
        break;
      case 123 * E:
        l[v++] = K(N) * x;
      case 125 * E:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            D = 0;
          case 59 + d:
            x == -1 && (N = T(N, /\f/g, "")), _ > 0 && K(N) - y && Fe(_ > 32 ? Dr(N + ";", a, n, y - 1) : Dr(T(N, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            N += ";";
          default:
            if (Fe(V = Ir(N, r, n, v, d, o, l, A, I = [], c = [], y), i), g === 123)
              if (d === 0)
                Ye(N, r, V, V, I, i, y, l, c);
              else
                switch ($ === 99 && Y(N, 3) === 110 ? 100 : $) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ye(e, V, V, a && Fe(Ir(e, V, V, 0, 0, o, l, A, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    Ye(N, V, V, V, [""], c, 0, l, c);
                }
        }
        v = d = _ = 0, E = x = 1, A = N = "", y = f;
        break;
      case 58:
        y = 1 + K(N), _ = S;
      default:
        if (E < 1) {
          if (g == 123)
            --E;
          else if (g == 125 && E++ == 0 && en() == 125)
            continue;
        }
        switch (N += Ue(g), g * E) {
          case 38:
            x = d > 0 ? 1 : (N += "\f", -1);
            break;
          case 44:
            l[v++] = (K(N) - 1) * x, x = 1;
            break;
          case 64:
            H() === 45 && (N += Ve(B())), $ = H(), d = y = K(A = N += an(je())), g++;
            break;
          case 45:
            S === 45 && K(N) == 2 && (E = 0);
        }
    }
  return i;
}
function Ir(e, r, n, a, o, i, f, l, p, v, d) {
  for (var y = o - 1, $ = o === 0 ? i : [""], _ = mr($), S = 0, E = 0, D = 0; S < a; ++S)
    for (var x = 0, g = Se(e, y + 1, y = Jt(E = f[S])), A = e; x < _; ++x)
      (A = Qr(E > 0 ? $[x] + " " + g : T(g, /&\f/g, $[x]))) && (p[D++] = A);
  return qe(e, r, n, o === 0 ? hr : l, p, v, d);
}
function sn(e, r, n) {
  return qe(e, r, n, pr, Ue(Qt()), Se(e, 2, -2), 0);
}
function Dr(e, r, n, a) {
  return qe(e, r, n, vr, Se(e, 0, a), Se(e, a + 1, -1), a);
}
function fe(e, r) {
  for (var n = "", a = mr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function cn(e, r, n, a) {
  switch (e.type) {
    case Gt:
      if (e.children.length)
        break;
    case qt:
    case vr:
      return e.return = e.return || e.value;
    case pr:
      return "";
    case Xr:
      return e.return = e.value + "{" + fe(e.children, a) + "}";
    case hr:
      e.value = e.props.join(",");
  }
  return K(n = fe(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function un(e) {
  var r = mr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function fn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function ln(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var dn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = H(), o === 38 && i === 12 && (n[a] = 1), !Re(i); )
    B();
  return Ce(r, z);
}, pn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Re(o)) {
      case 0:
        o === 38 && H() === 12 && (n[a] = 1), r[a] += dn(z - 1, n, a);
        break;
      case 2:
        r[a] += Ve(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = H() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ue(o);
    }
  while (o = B());
  return r;
}, hn = function(r, n) {
  return tt(pn(rt(r), n));
}, Mr = /* @__PURE__ */ new WeakMap(), vn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Mr.get(a)) && !o) {
      Mr.set(r, !0);
      for (var i = [], f = hn(n, i), l = a.props, p = 0, v = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, v++)
          r.props[v] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, mn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, yn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", En = function(r) {
  return r.type === "comm" && r.children.indexOf(yn) > -1;
}, gn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var v = l[p];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (En(v))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, nt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, bn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!nt(n[a]))
      return !0;
  return !1;
}, Fr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, _n = function(r, n, a) {
  nt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Fr(r)) : bn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Fr(r)));
};
function at(e, r) {
  switch (Ht(e, r)) {
    case 5103:
      return C + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return C + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return C + e + We + e + L + e + e;
    case 6828:
    case 4268:
      return C + e + L + e + e;
    case 6165:
      return C + e + L + "flex-" + e + e;
    case 5187:
      return C + e + T(e, /(\w+).+(:[^]+)/, C + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return C + e + L + "flex-item-" + T(e, /flex-|-self/, "") + e;
    case 4675:
      return C + e + L + "flex-line-pack" + T(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return C + e + L + T(e, "shrink", "negative") + e;
    case 5292:
      return C + e + L + T(e, "basis", "preferred-size") + e;
    case 6060:
      return C + "box-" + T(e, "-grow", "") + C + e + L + T(e, "grow", "positive") + e;
    case 4554:
      return C + T(e, /([^-])(transform)/g, "$1" + C + "$2") + e;
    case 6187:
      return T(T(T(e, /(zoom-|grab)/, C + "$1"), /(image-set)/, C + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return T(e, /(image-set\([^]*)/, C + "$1$`$1");
    case 4968:
      return T(T(e, /(.+:)(flex-)?(.*)/, C + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + C + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return T(e, /(.+)-inline(.+)/, C + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return T(e, /(.+:)(.+)-([^]+)/, "$1" + C + "$2-$3$1" + We + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~sr(e, "stretch") ? at(T(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, K(e) - 3 - (~sr(e, "!important") && 10))) {
        case 107:
          return T(e, ":", ":" + C) + e;
        case 101:
          return T(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + C + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + C + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return C + e + L + T(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return C + e + L + T(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return C + e + L + T(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return C + e + L + e + e;
  }
  return e;
}
var xn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case vr:
        r.return = at(r.value, r.length);
        break;
      case Xr:
        return fe([xe(r, {
          value: T(r.value, "@", "@" + C)
        })], o);
      case hr:
        if (r.length)
          return Xt(r.props, function(i) {
            switch (Zt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return fe([xe(r, {
                  props: [T(i, /:(read-\w+)/, ":" + We + "$1")]
                })], o);
              case "::placeholder":
                return fe([xe(r, {
                  props: [T(i, /:(plac\w+)/, ":" + C + "input-$1")]
                }), xe(r, {
                  props: [T(i, /:(plac\w+)/, ":" + We + "$1")]
                }), xe(r, {
                  props: [T(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Sn = [xn], Rn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(E) {
      var D = E.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Sn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(E) {
      for (var D = E.getAttribute("data-emotion").split(" "), x = 1; x < D.length; x++)
        i[D[x]] = !0;
      l.push(E);
    }
  );
  var p, v = [vn, mn];
  process.env.NODE_ENV !== "production" && v.push(gn({
    get compat() {
      return S.compat;
    }
  }), _n);
  {
    var d, y = [cn, process.env.NODE_ENV !== "production" ? function(E) {
      E.root || (E.return ? d.insert(E.return) : E.value && E.type !== pr && d.insert(E.value + "{}"));
    } : fn(function(E) {
      d.insert(E);
    })], $ = un(v.concat(o, y)), _ = function(D) {
      return fe(on(D), $);
    };
    p = function(D, x, g, A) {
      d = g, process.env.NODE_ENV !== "production" && x.map !== void 0 && (d = {
        insert: function(c) {
          g.insert(c + x.map);
        }
      }), _(D ? D + "{" + x.styles + "}" : x.styles), A && (S.inserted[x.name] = !0);
    };
  }
  var S = {
    key: n,
    sheet: new Bt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return S.sheet.hydrate(l), S;
}, ur = { exports: {} }, O = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function wn() {
  if (jr)
    return O;
  jr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function A(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case v:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case S:
                case _:
                case f:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function I(c) {
    return A(c) === v;
  }
  return O.AsyncMode = p, O.ConcurrentMode = v, O.ContextConsumer = l, O.ContextProvider = f, O.Element = r, O.ForwardRef = d, O.Fragment = a, O.Lazy = S, O.Memo = _, O.Portal = n, O.Profiler = i, O.StrictMode = o, O.Suspense = y, O.isAsyncMode = function(c) {
    return I(c) || A(c) === p;
  }, O.isConcurrentMode = I, O.isContextConsumer = function(c) {
    return A(c) === l;
  }, O.isContextProvider = function(c) {
    return A(c) === f;
  }, O.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, O.isForwardRef = function(c) {
    return A(c) === d;
  }, O.isFragment = function(c) {
    return A(c) === a;
  }, O.isLazy = function(c) {
    return A(c) === S;
  }, O.isMemo = function(c) {
    return A(c) === _;
  }, O.isPortal = function(c) {
    return A(c) === n;
  }, O.isProfiler = function(c) {
    return A(c) === i;
  }, O.isStrictMode = function(c) {
    return A(c) === o;
  }, O.isSuspense = function(c) {
    return A(c) === y;
  }, O.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === v || c === i || c === o || c === y || c === $ || typeof c == "object" && c !== null && (c.$$typeof === S || c.$$typeof === _ || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === D || c.$$typeof === x || c.$$typeof === g || c.$$typeof === E);
  }, O.typeOf = A, O;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function Cn() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function A(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === v || h === i || h === o || h === y || h === $ || typeof h == "object" && h !== null && (h.$$typeof === S || h.$$typeof === _ || h.$$typeof === f || h.$$typeof === l || h.$$typeof === d || h.$$typeof === D || h.$$typeof === x || h.$$typeof === g || h.$$typeof === E);
    }
    function I(h) {
      if (typeof h == "object" && h !== null) {
        var Ee = h.$$typeof;
        switch (Ee) {
          case r:
            var se = h.type;
            switch (se) {
              case p:
              case v:
              case a:
              case i:
              case o:
              case y:
                return se;
              default:
                var ne = se && se.$$typeof;
                switch (ne) {
                  case l:
                  case d:
                  case S:
                  case _:
                  case f:
                    return ne;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var c = p, V = v, N = l, Je = f, Te = r, Ke = d, He = a, Oe = S, G = _, Z = n, te = i, Pe = o, $e = y, pe = !1;
    function Ne(h) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), he(h) || I(h) === p;
    }
    function he(h) {
      return I(h) === v;
    }
    function Ae(h) {
      return I(h) === l;
    }
    function ke(h) {
      return I(h) === f;
    }
    function Ie(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Ze(h) {
      return I(h) === d;
    }
    function Xe(h) {
      return I(h) === a;
    }
    function ve(h) {
      return I(h) === S;
    }
    function me(h) {
      return I(h) === _;
    }
    function oe(h) {
      return I(h) === n;
    }
    function ye(h) {
      return I(h) === i;
    }
    function ie(h) {
      return I(h) === o;
    }
    function Qe(h) {
      return I(h) === y;
    }
    P.AsyncMode = c, P.ConcurrentMode = V, P.ContextConsumer = N, P.ContextProvider = Je, P.Element = Te, P.ForwardRef = Ke, P.Fragment = He, P.Lazy = Oe, P.Memo = G, P.Portal = Z, P.Profiler = te, P.StrictMode = Pe, P.Suspense = $e, P.isAsyncMode = Ne, P.isConcurrentMode = he, P.isContextConsumer = Ae, P.isContextProvider = ke, P.isElement = Ie, P.isForwardRef = Ze, P.isFragment = Xe, P.isLazy = ve, P.isMemo = me, P.isPortal = oe, P.isProfiler = ye, P.isStrictMode = ie, P.isSuspense = Qe, P.isValidElementType = A, P.typeOf = I;
  }()), P;
}
process.env.NODE_ENV === "production" ? ur.exports = wn() : ur.exports = Cn();
var Tn = ur.exports, ot = Tn, On = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Pn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, it = {};
it[ot.ForwardRef] = On;
it[ot.Memo] = Pn;
var $n = !0;
function Nn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var st = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  $n === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, An = function(r, n, a) {
  st(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function kn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var In = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Yr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Dn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Mn = /[A-Z]|^ms/g, ct = /_EMO_([^_]+?)_([^]*?)_EMO_/g, yr = function(r) {
  return r.charCodeAt(1) === 45;
}, Lr = function(r) {
  return r != null && typeof r != "boolean";
}, or = /* @__PURE__ */ ln(function(e) {
  return yr(e) ? e : e.replace(Mn, "-$&").toLowerCase();
}), ze = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ct, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return In[r] !== 1 && !yr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Fn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, jn = ["normal", "none", "initial", "inherit", "unset"], Vn = ze, Yn = /^-ms-/, Ln = /-(.)/g, Wr = {};
  ze = function(r, n) {
    if (r === "content" && (typeof n != "string" || jn.indexOf(n) === -1 && !Fn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Vn(r, n);
    return a !== "" && !yr(r) && r.indexOf("-") !== -1 && Wr[r] === void 0 && (Wr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Yn, "ms-").replace(Ln, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ut = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function we(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ut);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return J = {
          name: n.name,
          styles: n.styles,
          next: J
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Wn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, f = n(e);
        return J = i, we(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(ct, function(d, y, $) {
          var _ = "animation" + l.length;
          return l.push("const " + _ + " = keyframes`" + $.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + _ + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function Wn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += we(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Lr(f) && (a += or(i) + ":" + ze(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ut);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Lr(f[l]) && (a += or(i) + ":" + ze(i, f[l]) + ";");
        else {
          var p = we(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += or(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Dn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var zr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ft;
process.env.NODE_ENV !== "production" && (ft = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, Ur = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += we(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Yr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += we(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(Yr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ft, function($) {
    return p = $, "";
  })), zr.lastIndex = 0;
  for (var v = "", d; (d = zr.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = kn(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, zn = function(r) {
  return r();
}, Un = Q["useInsertionEffect"] ? Q["useInsertionEffect"] : !1, Bn = Un || zn, Ge = {}.hasOwnProperty, Er = /* @__PURE__ */ Q.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Rn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Er.displayName = "EmotionCacheContext");
Er.Provider;
var qn = function(r) {
  return /* @__PURE__ */ Kr(function(n, a) {
    var o = Dt(Er);
    return r(n, o, a);
  });
}, lt = /* @__PURE__ */ Q.createContext({});
process.env.NODE_ENV !== "production" && (lt.displayName = "EmotionThemeContext");
var Br = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Gn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Br(n[1]);
}, Jn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Kn = function(r) {
  return r.replace(/\$/g, "-");
}, Hn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Gn(n[a]);
      if (o) {
        if (Jn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Kn(o);
      }
    }
}, fr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", lr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", dt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ge.call(n, o) && (a[o] = n[o]);
  if (a[fr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Hn(new Error().stack);
    i && (a[lr] = i);
  }
  return a;
}, Zn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return st(n, a, o), Bn(function() {
    return An(n, a, o);
  }), null;
}, pt = /* @__PURE__ */ qn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[fr], i = [a], f = "";
  typeof e.className == "string" ? f = Nn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = Ur(i, void 0, Q.useContext(lt));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[lr];
    p && (l = Ur([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var v = {};
  for (var d in e)
    Ge.call(e, d) && d !== "css" && d !== fr && (process.env.NODE_ENV === "production" || d !== lr) && (v[d] = e[d]);
  return v.ref = n, v.className = f, /* @__PURE__ */ Q.createElement(Q.Fragment, null, /* @__PURE__ */ Q.createElement(Zn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ Q.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (pt.displayName = "EmotionCssPropInternal");
var ht = pt;
function re(e, r, n) {
  return Ge.call(r, "css") ? Le.jsx(ht, dt(e, r), n) : Le.jsx(e, r, n);
}
function qr(e, r, n) {
  return Ge.call(r, "css") ? Le.jsxs(ht, dt(e, r), n) : Le.jsxs(e, r, n);
}
const Xn = {
  default: `--${U}-grayBlue-06`,
  processing: `--${U}-blue-03`,
  success: `--${U}-green-03`,
  warning: `--${U}-yellow-03`,
  error: `--${U}-red-03`
}, Qn = Vt`
  from {
    transform: scale(0, 0);
  }

  to {
    transform: scale(1, 1);
  }
`, ea = ae`
  display: inline-block;
  position: relative;
  line-height: 1;
`;
function Gr(e, r, n) {
  let a = "";
  return !n && r && (a += `
      position: absolute;
      transform: translate(50%, -50%);
      transform-origin: 100% 0;
      right: 0px;
    `), ae`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    border: solid 1px ${ee(`--${U}-white-01`)};
    background-color: ${e};
    display: inline-block;
    ${a}
  `;
}
function dr(e, r, n) {
  const a = n > 1 ? "padding: 0 6px;" : "", o = r ? `
    position: absolute;
    transform: translate(50%, -50%);
    transform-origin: 100% 0;
    right: 0px;
  ` : "";
  return ae`
    min-width: 20px;
    height: 20px;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    border-radius: 10px;
    box-sizing: border-box;
    transition: 0.15s all linear;
    border: solid 2px ${ee(`--${U}-white-01`)};
    background-color: ${e};
    color: ${ee(`--${U}-white-01`)};
    text-align: center;
    white-space: pre;
    ${o + a}
  `;
}
function ra(e = !1) {
  return e ? ae`
        animation-name: ${Qn};
        animation-timing-function: cubic-bezier(0.3, 1.3, 0.3, 1);
        animation-duration: 0.5s;
        animation-iteration-count: 1;
        animation-play-state: running;
      ` : ae``;
}
const ta = ae`
  display: inline-flex;
  align-items: center;
`, na = ae`
  margin-left: 9px;
  font-size: 12px;
  line-height: 1.33;
  color: ${ee(`--${U}-grayBlue-02`)};
`;
function aa(e, r, n) {
  let a;
  return r && (a = ee(`--${U}-${r}-03`), a || (a = r)), n && (a = ee(Xn[n])), a = a || (Hr(e) ? ee(`--${U}-white-01`) : ee(`--${U}-red-03`)), a;
}
function oa(e) {
  const r = Mt();
  return Ft(() => {
    r.current = e;
  }), r.current;
}
const ia = ee(`--${U}-red-03`);
function sa(e) {
  const { count: r, color: n = ia, hasChildren: a, ...o } = e, i = oa(r), f = r !== i;
  return re("span", { css: dr(n, a ?? !1, r.length), ...Zr(o), children: re("span", { css: ra(f), children: r }, r) });
}
const ca = Kr((e, r) => {
  const { count: n = 0, text: a, dot: o, maxCount: i = 99, colorScheme: f, offset: l, status: p, children: v, ...d } = e, [y, $] = l || [], _ = {};
  y && (_.marginRight = -y), $ && (_.marginTop = $);
  let S = aa(n, f, p);
  const E = !!v, D = jt(() => {
    if (p)
      return qr("span", { css: ta, style: _, children: [re("span", { css: Gr(S, E, !0) }), a && re("span", { css: na, children: a })] });
    if (Hr(n))
      return re("span", { css: dr(S, E, 0), style: _, children: n });
    if (a)
      return re("span", { css: dr(S, E, a.length), style: _, children: a });
    if (o && n && n > 0)
      return re("span", { css: Gr(S, E), style: _ });
    let x = n && n > i ? `${i}+` : `${n}`;
    return n && n > 0 ? re(sa, { count: x, hasChildren: E, color: S, style: _ }) : null;
  }, [S, n, o, _, E, i, p, a]);
  return qr("span", { css: [ea, Yt(e)], ref: r, ...Zr(d), children: [v, D] });
});
ca.displayName = "Badge";
export {
  ca as Badge
};
//# sourceMappingURL=index.js.map
